import React from "react";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";

const VirasatV2DefaultResPage = ({ components, props }) => {
    const dispatch = useDispatch()

    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultResPage-subheader":
                return <div className="VirasatV2DefaultResPage-conatiner-inner-des">- {component?.Props?.text} -</div>
            case "VirasatDefaultResPage-headertext":
                return <div className="VirasatV2DefaultResPage-conatiner-inner-title">{component?.Props?.text}</div>
            case "VirasatDefaultResPage-btncont":
                return <div className="VirasatV2DefaultResPage-conatiner-inner-btnCont">
                    {component?.Components?.map((button, key) => {
                        return (
                            <Button
                                text={button?.Props?.text}
                                width={button?.Props?.width}
                                isBorder={button?.Props?.isBorder}
                                key={key}
                                onClick={() => {
                                    if (button?.Props?.href && button?.Props?.href !== "") {
                                        if (button?.Props?.href?.includes("https://")) {
                                            window.open(button?.Props?.href, '_blank')
                                        } else {
                                            window.location.href = button?.Props?.href && button?.Props?.href !== "" ? button?.Props?.href : "/"
                                        }
                                    }
                                    else {
                                        dispatch(setIsComing(true))
                                    }
                                }} />
                        )
                    })}

                </div>
            default:
                return <div />
        }

    }

    return (
        <div className="VirasatV2DefaultResPage">
            <div className="VirasatV2DefaultResPage-conatiner"
                style={{
                    backgroundImage: `linear-gradient(90.01deg, rgba(25, 34, 51, 0.9) 44.93%, rgba(82, 69, 69, 0) 115.18%)

, url(${props?.bgSrc})`
                }}>
                <img alt="" src={props?.leftSrc} className="VirasatV2DefaultResPage-conatiner-indimg" />

                <div className="VirasatV2DefaultResPage-conatiner-inner">

                    {sortByOrderAscending(components).map((component, key) => {
                        return (
                            getComponents(component)
                        )
                    })}
                </div>

                <img alt="" src={props?.rightSrc} className="VirasatV2DefaultResPage-conatiner-vegimg" />

            </div>

        </div>
    )
}
export default VirasatV2DefaultResPage